import type { FC } from "react";

import { CustomButton, DialogBody } from "@/components/atoms";
import { DialogClose } from "@/components/ui/dialog";
import { rootStore } from "@/store/RootStore";
import { wordToUpper } from "@/utils/wordToUpper";

import type { ActionStateType } from "./type";

interface ActionConfirmProps {
  state: ActionStateType;
  name: string;
  callback: () => void | Promise<void>;
  actionName: string;
  btnConfirmTitle?: string;
  isPending?: boolean;
  extraText?: string;
}

const ActionConfirm: FC<ActionConfirmProps> = ({
  state,
  name,
  callback,
  actionName,
  btnConfirmTitle,
  isPending,
  extraText,
}) => {
  const { isBranchAccess, isBrandAccess, isGroupAccess, isAdmin } =
    rootStore.authStore;

  const listName =
    (isBranchAccess && "branch's") ||
    (isBrandAccess && "brand's") ||
    (isGroupAccess && "group's") ||
    (isAdmin && "admin's") ||
    "";

  const handleConfirmClick = () => {
    if (isPending) {
      return;
    }
    void callback();
  };

  return (
    <DialogBody title={`${wordToUpper(actionName)} ${state}`} classes="gap-2">
      <p className="text-sm text-gray-950 mb-2">
        Are you sure you want to {actionName}
        <span className="font-bold pl-1">{name}</span> from the {listName} list?
        <span> {extraText}</span>
      </p>
      <div className="flex flex-col gap-5 pt-2">
        <div className="flex justify-between gap-3">
          <DialogClose asChild>
            <CustomButton
              variant="light"
              type="button"
              className="w-[48%]"
              data-testid="deactivate-user-cancel-button"
            >
              Cancel
            </CustomButton>
          </DialogClose>

          <CustomButton
            type="button"
            className="w-[48%]"
            data-testid="deactivate-user-submit-button"
            onClick={handleConfirmClick}
            variant="destructive"
            isPending={isPending}
            disabled={isPending}
          >
            {btnConfirmTitle ?? "Confirm"}
          </CustomButton>
        </div>
      </div>
    </DialogBody>
  );
};

export default ActionConfirm;
